<template>
  <CCard class="shadow-sm rounded-3 bg-white">
    <CRow class="">
      <CCol md="12"> <CCardHeader style="background-color: #145654"
          class="border-bottom d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0 text-white">
            <CIcon name="cil-people" size="xl" /> {{ $t('staffMgmt.pageTitle') }}
          </h4>
          <div class="d-flex align-items-center gap-2">
            <CButton v-if="selectedUsers.length > 0" color="danger" shape="pill" @click="deleteMultipleUsers()" class="mr-2">
              <CIcon name="cil-trash" /> {{ $t('staffMgmt.deleteSelected') }} ({{ selectedUsers.length }})
            </CButton>
            <CButton color="success" shape="pill" @click="openAddModal()">
              <CIcon name="cil-user-follow" />
              &nbsp;{{ $t('staffMgmt.addStaff') }}
            </CButton>
          </div>
        </CCardHeader>

        <CCardBody>
          <CDataTable class="custom-pagination" :items="tableUsers" :fields="tableFields" hover striped sorter
            :pagination="{ doubleArrows: false, align: 'center' }" :items-per-page="perPage" :active-page="activePage" @page-change="activePage = $event" @pagination-change="perPage = $event" @filtered-items-change="onFilteredItemsChange"
            table-filter items-per-page-select responsive>

            <template #select-header>
              <input type="checkbox" @change="toggleSelectAll($event.target.checked)" :checked="isPageSelected" style="cursor: pointer; width: 1.2em; height: 1.2em;" />
            </template>

            <template #select="{ item }">
              <td class="text-center align-middle">
                <input type="checkbox" :value="item._id" v-model="selectedUsers" style="cursor: pointer; width: 1.2em; height: 1.2em;" />
              </td>
            </template>

            <template #actions="{ item }">
              <td class="text-center">
                <div class="d-flex justify-content-center align-items-center gap-2 action-buttons">
                  <CButton size="sm" color="warning" shape="pill" @click="openEditModal(item)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton size="sm" color="danger" shape="pill" @click="deleteUser(item)">
                    <CIcon name="cil-trash" />
                  </CButton>
                </div>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCol>
    </CRow>

    <CModal :title="$t('staffMgmt.addModal')" :show.sync="showaddModal" size="lg" color="warning" centered>
      <CModalBody v-if="addUser">
        <CForm>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <label>{{ $t('staffMgmt.firstName') }} <span class="text-danger">*</span></label>
                <CInput v-model="addUser.name" />
              </CCol>
              <CCol sm="6">
                <label>{{ $t('staffMgmt.lastName') }} <span class="text-danger">*</span></label>
                <CInput v-model="addUser.surname" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <label>{{ $t('staffMgmt.email') }} <span class="text-danger">*</span></label>
                <CInput v-model="addUser.email" />
              </CCol>
              <CCol sm="6">
                <label>{{ $t('staffMgmt.phone') }} <span class="text-danger">*</span></label>
                <CInput v-model="addUser.mobile_phone" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <label>{{ $t('staffMgmt.userType') }} <span class="text-danger">*</span></label>
                <CSelect :options="roleOptions" :value="addUser.role" @change="onChangeAddRole" />
              </CCol>
              <CCol sm="6">
                <label>{{ divisionLabel }} <span class="text-danger" v-if="addUser.role !== 'admin'">*</span></label>
                <CSelect v-if="addUser.role !== 'admin'" :options="categoryOptions" :value="addUser.department"
                  @change="(e) => (addUser.department = e.target.value)" />
                <CInput v-else :value="allDivisionsLabel" disabled />
              </CCol>
            </CRow>
          </CCardBody>
        </CForm>
      </CModalBody>
      <template #footer>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <CButton shape="pill" color="info" @click="triggerFileUpload" class="mr-2">
              <CIcon name="cil-file" /> {{ $t('staffMgmt.addViaXlsx') }}
            </CButton>
            <a 
              href="/filexlsx/Template Add Person _ SmartFix MFU.xlsx" 
              download
              class="text-info font-weight-bold"
              style="text-decoration: underline;"
            >
              {{ $t('staffMgmt.templateFile') }}
            </a>
          </div>
          <div>
            <CButton shape="pill" color="danger" @click="showaddModal = false">{{ $t('mgmt.cancel') }}</CButton>
            <CButton shape="pill" color="success" @click="saveaddUser">{{ $t('mgmt.add') }}</CButton>
          </div>
        </div>
        <input type="file" ref="fileInput" accept=".xlsx, .xls" class="d-none" @change="handleFileUpload" />
      </template>
    </CModal>

    <CModal :title="$t('staffMgmt.editModal')" :show.sync="showeditModal" size="lg" color="warning" centered>
      <CModalBody v-if="editUser">
        <CForm>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput :label="$t('staffMgmt.firstName')" v-model="editUser.name" />
              </CCol>
              <CCol sm="6">
                <CInput :label="$t('staffMgmt.lastName')" v-model="editUser.surname" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CInput :label="$t('staffMgmt.email')" v-model="editUser.email" disabled/>
              </CCol>
              <CCol sm="6">
                <CInput :label="$t('staffMgmt.phone')" v-model="editUser.mobile_phone" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CSelect :label="$t('staffMgmt.userType')" :options="roleOptions" :value="editUser.role"
                  @change="onChangeEditRole" />
              </CCol>
              <CCol sm="6">
                <CSelect v-if="editUser.role !== 'admin'" :label="divisionLabel" :options="categoryOptions"
                  :value="editUser.department" @change="(e) => (editUser.department = e.target.value)" />
                <CInput v-else :label="divisionLabel" :value="allDivisionsLabel" disabled />
              </CCol>
            </CRow>
          </CCardBody>
        </CForm>
      </CModalBody>
      <template #footer>
        <CButton shape="pill" color="danger" @click="showeditModal = false">{{ $t('mgmt.cancel') }}</CButton>
        <CButton shape="pill" color="success" @click="saveUser">{{ $t('mgmt.save') }}</CButton>
      </template>
    </CModal>

    <CModal :title="$t('staffMgmt.previewModal')" :show.sync="showPreviewModal" size="xl" color="info" centered>
      <CModalBody>
        <CDataTable :items="previewUsers" :fields="previewFields" hover striped responsive pagination
          :items-per-page="5">
        </CDataTable>
      </CModalBody>
      <template #footer>
        <CButton shape="pill" color="danger" @click="showPreviewModal = false">{{ $t('mgmt.cancel') }}</CButton>
        <CButton shape="pill" color="success" @click="confirmUpload">{{ $t('staffMgmt.confirmBulk') }}</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      selectedUsers: [],
      tableUsers: [],
      showaddModal: false,
      showeditModal: false,
      addUser: null,
      editUser: null,
      roleOptions: [
        { value: "admin", label: "Admin" },
        { value: "supervisor", label: "Supervisor" },
        { value: "technician", label: "Technician" },
      ],
      categoryOptions: [],
      showPreviewModal: false,
      previewUsers: [],
      activePage: 1,
      perPage: 5,
      filteredUsers: [],
    };
  },
  computed: {
    divisionLabel() {
      return this.$store.state.locale.lang === "th"
        ? "ฝ่าย (ประเภทงานซ่อม)"
        : "Division (repair category)";
    },
    allDivisionsLabel() {
      return this.$store.state.locale.lang === "th" ? "ทุกฝ่าย" : "All divisions";
    },
    selectDivisionLabel() {
      return this.$store.state.locale.lang === "th" ? "โปรดเลือกฝ่าย" : "Select division";
    },
    tableFields() {
      return [
        { key: "select", label: "", _style: "width: 1%; text-align: center;", sorter: false, filter: false },
        { key: "name", label: this.$t("staffMgmt.firstName") },
        { key: "surname", label: this.$t("staffMgmt.lastName") },
        { key: "email", label: this.$t("staffMgmt.email") },
        { key: "mobile_phone", label: this.$t("staffMgmt.phone") },
        { key: "role", label: this.$t("staffMgmt.userType") },
        { key: "deptNameDisplay", label: this.divisionLabel },
        { key: "actions", label: "" },
      ];
    },
    currentPageUsers() {
      const start = (this.activePage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredUsers.slice(start, end);
    },
    isPageSelected() {
      if (this.currentPageUsers.length === 0) return false;
      return this.currentPageUsers.every(u => this.selectedUsers.includes(u._id));
    },
    previewFields() {
      return [
        { key: "name", label: this.$t("staffMgmt.firstName") },
        { key: "surname", label: this.$t("staffMgmt.lastName") },
        { key: "email", label: this.$t("staffMgmt.email") },
        { key: "mobile_phone", label: this.$t("staffMgmt.phone") },
        { key: "role", label: this.$t("staffMgmt.userType") },
        { key: "deptNameDisplay", label: this.divisionLabel },
      ];
    },
  },
  mounted() {
    this.loadUsers();
    this.loadDepartments();
  },
  methods: {
    async loadDepartments() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_APP_URL}/category`);
        const data = res.data.data;
        this.categoryOptions = [
          { value: "", label: this.selectDivisionLabel, disabled: true },
          { value: "all", label: this.allDivisionsLabel, disabled: true },
          ...data.map((item) => ({
            value: item._id,
            label: item.departmentName,
          })),
        ];
      } catch (err) {
        console.error("Error loading departments:", err);
      }
    },
    async loadUsers() {
      try {

        const res = await axios.get(`${process.env.VUE_APP_APP_URL}/user/admin_user`);

        this.tableUsers = res.data.map(user => ({
          ...user,
          mobile_phone: user.mobile_phone || "",
          department: user.department?._id || user.department || "",
          deptNameDisplay: user.department?.departmentName || user.department || ""
        }));
        this.filteredUsers = JSON.parse(JSON.stringify(this.tableUsers));
      } catch (err) {
        console.error("Error loading users:", err);
      }
    },
    openAddModal() {
      this.addUser = {
        name: "",
        surname: "",
        email: "",
        mobile_phone: "",
        role: "technician",
        department: "",
      };
      this.showaddModal = true;
    },
    onChangeAddRole(e) {
      this.addUser.role = e.target.value;
      if (this.addUser.role === "admin") {
        this.addUser.department = "all";
      } else if (this.addUser.department === "all") {
        this.addUser.department = "";
      }
    },
    onChangeEditRole(e) {
      this.editUser.role = e.target.value;
      if (this.editUser.role === "admin") {
        this.editUser.department = "all";
      } else if (this.editUser.department === "all") {
        this.editUser.department = "";
      }
    },
    async saveaddUser() {
      if (
        !this.addUser.name ||
        !this.addUser.surname ||
        !this.addUser.email ||
        !this.addUser.mobile_phone ||
        !this.addUser.role ||
        (this.addUser.role !== "admin" && !this.addUser.department)
      ) {
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.errFillAll"), "error");
        return;
      }
      try {
        const payload = { ...this.addUser };
        if (payload.role === "admin" && payload.department === "all") {
          payload.department = "";
        }

        const res = await axios.post(
          `${process.env.VUE_APP_APP_URL}/user/admin_user`,
          payload
        );
        if (res.data?.success === false) {
          Swal.fire(this.$t("mgmt.error"), res.data.message, "error");
          return;
        }
        Swal.fire(this.$t("mgmt.success"), res.data.message, "success");
        this.showaddModal = false;
        this.loadUsers();
      } catch (err) {
        Swal.fire(
          this.$t("mgmt.error"),
          err.response?.data?.message || this.$t("mgmt.addFail"),
          "error"
        );
      }
    },
    openEditModal(item) {
      this.editUser = JSON.parse(JSON.stringify(item));
      if (this.editUser.role === "admin" && !this.editUser.department) {
        this.editUser.department = "all";
      }
      this.showeditModal = true;
    },
    async saveUser() {
      if (
        !this.editUser.name ||
        !this.editUser.surname ||
        !this.editUser.email ||
        !this.editUser.mobile_phone ||
        !this.editUser.role ||
        (this.editUser.role !== "admin" && !this.editUser.department)
      ) {
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.errFillAll"), "error");
        return;
      }
      try {

        const payload = { ...this.editUser };
        if (payload.role === "admin" && payload.department === "all") {
          payload.department = "";
        }

        await axios.put(`${process.env.VUE_APP_APP_URL}/user/admin_user`, payload);

        Swal.fire(this.$t("mgmt.success"), this.$t("mgmt.editSaved"), "success");
        this.showeditModal = false;
        this.loadUsers();
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.editFail"), "error");
      }
    },
    async deleteUser(item) {
      const confirm = await Swal.fire({
        title: this.$t("mgmt.deleteUserTitle"),
        text: `${item.name} ${item.surname}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirm"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });
      if (!confirm.isConfirmed) return;

      const confirm2 = await Swal.fire({
        title: this.$t("mgmt.sureDelete"),
        text: `${item.name} ${item.surname} — ${this.$t("mgmt.demoteUserSuffix")}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirmDelete"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });
      if (!confirm2.isConfirmed) return;

      try {
        const res = await axios.put(`${process.env.VUE_APP_APP_URL}/user/del_user`, item);
        if (res.data) {
          Swal.fire(this.$t("mgmt.success"), this.$t("mgmt.demoteSuccess"), "success");
          
          // เอาออกจากที่เลือกไว้ด้วยเผื่อว่าถูกลบไปแล้ว
          this.selectedUsers = this.selectedUsers.filter(id => id !== item._id);
          this.loadUsers();
        }
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), err.response?.data?.message || this.$t("mgmt.errOperation"), "error");
      }
    },
    onFilteredItemsChange(items) {
      this.filteredUsers = items;
    },
    toggleSelectAll(checked) {
      const pageIds = this.currentPageUsers.map(u => u._id);
      if (checked) {
        const newSelected = [...this.selectedUsers];
        pageIds.forEach(id => {
          if (!newSelected.includes(id)) {
            newSelected.push(id);
          }
        });
        this.selectedUsers = newSelected;
      } else {
        this.selectedUsers = this.selectedUsers.filter(id => !pageIds.includes(id));
      }
    },
    async deleteMultipleUsers() {
      const confirm = await Swal.fire({
        title: this.$t("mgmt.deleteUserBulkTitle"),
        text: `${this.$t("mgmt.countItems")} ${this.selectedUsers.length} ${this.$t("mgmt.itemsUnit")}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirm"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });
      if (!confirm.isConfirmed) return;

      const confirm2 = await Swal.fire({
        title: this.$t("mgmt.sureDelete"),
        text: this.$t("mgmt.demoteUsersBulk"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("mgmt.confirmDelete"),
        cancelButtonText: this.$t("mgmt.cancel"),
      });
      if (!confirm2.isConfirmed) return;

      Swal.fire({
        title: this.$t("mgmt.loadingDelete"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      let successCount = 0;
      let failCount = 0;

      for (const userId of this.selectedUsers) {
        try {
          const res = await axios.put(`${process.env.VUE_APP_APP_URL}/user/del_user`, { _id: userId });
          if (res.data) successCount++;
        } catch (err) {
          failCount++;
        }
      }

      Swal.fire({
        title: failCount === 0 ? this.$t("mgmt.success") : this.$t("mgmt.doneTitle"),
        html: `${this.$t("mgmt.batchDeleted")} ${successCount} ${this.$t("mgmt.itemsUnit")}` + (failCount > 0 ? `<br>${this.$t("mgmt.batchFailed")} ${failCount} ${this.$t("mgmt.itemsUnit")}` : ""),
        icon: failCount === 0 ? "success" : "warning"
      });
      
      this.selectedUsers = [];
      this.loadUsers();
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      Swal.fire({
        title: this.$t("mgmt.loadingRead"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          const parsedUsers = [];

          for (const row of jsonData) {
            const name = row["ชื่อ"] || row["First name"] || row["Name"];
            const surname = row["นามสกุล"] || row["Last name"] || row["Surname"];
            const email = row["อีเมล"] || row["Email"];
            const mobile = row["เบอร์โทรศัพท์"] || row["Phone"] || row["Mobile"];
            let roleStr = (row["ประเภทผู้ใช้"] || row["Role"] || row["User type"]) ? (row["ประเภทผู้ใช้"] || row["Role"] || row["User type"]).toString().toLowerCase().trim() : "";
            const deptName = (row["หน่วยงาน"] || row["Department"]) ? (row["หน่วยงาน"] || row["Department"]).toString().trim() : "";

            if (roleStr === "technicain") roleStr = "technician";

            let deptId = "";
            let deptNameDisplay = deptName;

            if (roleStr === "admin") {
              deptId = "";
              deptNameDisplay = "-";
            } else {
              const deptObj = this.categoryOptions.find(opt => opt.label === deptName);
              if (deptObj) {
                deptId = deptObj.value;
              }
            }

            if (name || surname || email) { // Simple check to avoid empty rows
              parsedUsers.push({
                name,
                surname,
                email,
                mobile_phone: mobile ? mobile.toString() : "",
                role: roleStr,
                department: deptId,
                deptNameDisplay: deptNameDisplay
              });
            }
          }

          this.previewUsers = parsedUsers;
          this.showPreviewModal = true;
          Swal.close();

          // Reset file input
          event.target.value = null;

        } catch (error) {
          console.error(error);
          Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.fileReadError"), "error");
          event.target.value = null;
        }
      };

      reader.readAsArrayBuffer(file);
    },
    async confirmUpload() {
      if (this.previewUsers.length === 0) {
        Swal.fire(this.$t("mgmt.noData"), this.$t("mgmt.noDataToSave"), "warning");
        return;
      }

      Swal.fire({
        title: this.$t("mgmt.loadingSave"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      let successCount = 0;
      let failCount = 0;
      const errors = [];

      for (const user of this.previewUsers) {
        // Validation
        if (!user.name || !user.surname || !user.email || !user.role) {
          failCount++;
          errors.push(`${user.name || "Unknown"}: ${this.$t("mgmt.rowIncompleteSuffix")}`);
          continue;
        }

        const payload = {
          name: user.name,
          surname: user.surname,
          email: user.email,
          mobile_phone: user.mobile_phone,
          role: user.role,
          department: user.department
        };

        try {
          const res = await axios.post(`${process.env.VUE_APP_APP_URL}/user/admin_user`, payload);
          if (res.data && res.data.success !== false) {
            successCount++;
          } else {
            failCount++;
            errors.push(`${user.name}: ${res.data.message || 'Failed'}`);
          }
        } catch (apiErr) {
          failCount++;
          errors.push(`${user.name}: ${apiErr.response?.data?.message || apiErr.message}`);
        }
      }

      let msg = `${this.$t("mgmt.batchAdded")} ${successCount} ${this.$t("mgmt.itemsUnit")}`;
      if (failCount > 0) {
        msg += `<br>${this.$t("mgmt.batchFailed")} ${failCount} ${this.$t("mgmt.itemsUnit")}`;
        console.warn("Upload errors:", errors);
      }

      Swal.fire({
        title: failCount === 0 ? this.$t("mgmt.doneTitle") : this.$t("mgmt.donePartial"),
        html: msg,
        icon: failCount === 0 ? "success" : "warning"
      });

      this.showPreviewModal = false;
      this.previewUsers = [];
      this.loadUsers();
    },
  },
};
</script>

<style>
/* CSS เพิ่มเติม */
.gap-2 {
  gap: 0.5rem; /* ระยะห่างปกติ 8px */
}

@media (max-width: 576px) {
  .gap-2 {
    gap: 0.85rem; /* เพิ่มระยะห่างในมือถือให้อีกนิด */
  }
}

.custom-pagination .page-item.active .page-link {
  background-color: #2ba9a5 !important;
  border-color: #2ba9a5 !important;
  color: #ffffff;
}

.custom-pagination .page-item .page-link {
  color: #414141;
}

.custom-pagination .page-item:not(.active) .page-link:hover {
  background-color: #f0f0f0;
}

.modal-header {
  background-color: #2a8577 !important;
}
</style>